import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'capitalizeStr'})
export class capitalizeStr implements PipeTransform {
  transform(input: string): string {
    return input.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
  }
}